import { clsx } from 'clsx'

import { FC } from 'react'

import SignUpLessonComponent from '@/app/shared/components/modals/sign-up-lesson/sign-up-lesson.component'
import { IClassName } from '@/app/shared/interfaces/common.interface'
import { ITitleEditorImage } from '@/app/shared/interfaces/content.interface'
import { ITypeSite } from '@/app/shared/store/layout.store'
import useModal from '@/app/shared/store/modals.store'
import { ButtonComponent } from '@/app/shared/ui/button'
import { t } from '@/core/lib/locale/i18n'

// interface
interface IStep extends IClassName {
  data: ITitleEditorImage
  count: string
  typeSite: ITypeSite
}

// component
const StepComponent: FC<Readonly<IStep>> = ({ data, count, className, typeSite }) => {
  const open = useModal((state) => state.open)

  const handleOpenModal = () => {
    open({
      component: SignUpLessonComponent,
      props: {
        title: typeSite === 'offline' ? t.enter_to_free_lesson() : t.sign_up_text(),
      },
    })
  }

  // return
  return (
    <div
      className={clsx(
        'grid gap-5 rounded-large border-2 border-secondary bg-white p-[30px] desktop:gap-10 large:p-[40px_50px]',
        className,
      )}
    >
      <div className={'flex flex-wrap justify-start'}>
        <span
          className={
            'mr-10 text-[60px] font-extrabold 2xl:text-[100px] desktop:text-[80px] large:text-[90px]'
          }
        >
          {count}
        </span>
        <span
          className={
            'w-full text-[28px] font-extrabold text-secondary extraMobile:text-[32px] desktop:text-[34px] large:w-[75%] large:text-[44px]'
          }
        >
          {data.title}
        </span>
      </div>
      <div
        className={'text-[18px] large:text-[22px]'}
        dangerouslySetInnerHTML={{ __html: data.description }}
      />
      {count === '01' && (
        <ButtonComponent
          color={'secondary'}
          size={'lg'}
          onClick={handleOpenModal}
          className={'mx-auto w-fit text-black'}
        >
          {t.fill_form()}
        </ButtonComponent>
      )}
    </div>
  )
}

export default StepComponent
